var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinshidaolu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 25",
    x1: 5.04049,
    y1: 0.95923,
    x2: 0.915486,
    y2: 14.3967,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 26",
    y1: -0.5,
    x2: 14.0564,
    y2: -0.5,
    transform: "matrix(0.293461 0.955971 0.955971 -0.293461 11.4375 0.8125)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 27",
    d: "M8.18749 1.0625L8.1875 14.5",
    stroke: "black",
    strokeDasharray: "2.4 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinshidaolu);
export default __webpack_public_path__ + "static/media/linshidaolu.cd029a5ca526d4003d1a7a3bfa1baa0a.svg";
export { ForwardRef as ReactComponent };